import axios from 'axios';
import { API, authHeaders } from './client';

export const getDashboardStats = (token) =>
  axios.get(`${API}/stats/dashboard`, authHeaders(token)).then(r => r.data);
